import Immutable, { OrderedMap } from 'immutable';
import { SelectOption } from 'components/inputs/BaseSelect';
import { Discipline, DisciplineDesignator } from 'records/Discipline';

export type UpdateMultiplePubReqsId = string;

export interface RawUpdateMultiplePubReq {
  type: string;
}

export interface UpdateMultiplePubReqData {
  type: string;
}

const defaultValues: UpdateMultiplePubReqData = {
  type: 'UpdateMultiplePubReq',
};

export const UpdateMultiplePubReqFactory = Immutable.Record(
  defaultValues,
  'UpdateMultiplePubReq'
);

export class UpdateMultiplePubReq extends UpdateMultiplePubReqFactory {
  static deserialize(
    rawUpdateMultiplePubReq: RawUpdateMultiplePubReq
  ): UpdateMultiplePubReq {
    return new UpdateMultiplePubReq({
      ...rawUpdateMultiplePubReq,
    });
  }

  serialize(): RawUpdateMultiplePubReq {
    return this.toJS();
  }
}
